






































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Picture } from '@/components/atoms';
import Arrow from '@/components/icons/Arrow.vue';
import StatusTag from '@/componentsV2/atoms/StatusTag/StatusTag.vue';

@Component({
  components: {
    Picture,
    Arrow,
    StatusTag
  }
})
export default class CustomerHeader extends Vue {
  @Prop({ default: '' }) avatarUrl?: string;
  @Prop({ default: '' }) nameInitials?: string;
  @Prop(String) title!: string;
  @Prop(String) since!: string;
  @Prop(String) storeVisits!: string;
  @Prop(String) bornOn!: string;
  @Prop({ default: false }) isActive?: boolean;

  get imageSrc() {
    return require(`@/assets/img/members/birthday-icon.png`);
  }

  close() {
    this.$router.push('/performance/customer-center');
  }
}
